import { useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import styles from "./InputWithSearch.module.css";

export default function InputWithSearch<T>({ value, placeholder, debouncedOnChange, searchResult, getKey, getItemText, onSelect, onValueChange }: InputWithSearchProps<T>) {
    const [isInputInFocus, setIsInputInFocus] = useState(false);
    const debouncedOnChangeCallback = useDebouncedCallback(debouncedOnChange, 500);

    return (
        <div className={styles.container}>
            <input
                className={styles.input}
                value={value}
                placeholder={placeholder}
                onFocus={() => setIsInputInFocus(true)}
                onBlur={() => setIsInputInFocus(false)}
                onChange={(e) => {
                    const value = e.target.value;
                    onValueChange(value);
                    debouncedOnChangeCallback(value);
                }}
            />

            {isInputInFocus && value === searchResult.query && searchResult.items.length > 0 && (
                <div className={styles.searchResult}>
                    {searchResult.items.map((item) => (
                        <div
                            key={getKey(item)}
                            className={styles.searchResultItem}
                            onMouseDown={() => {
                                const value = getItemText(item);
                                onValueChange(value);
                                onSelect(item);
                                setIsInputInFocus(false);
                            }}
                        >
                            {getItemText(item)}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

type InputWithSearchProps<T> = {
    value: string;
    placeholder?: string;
    debouncedOnChange: (value: string) => void;
    searchResult: {
        query: string;
        items: readonly T[];
    };
    getKey: (item: T) => string | number;
    getItemText: (item: T) => string;
    onSelect: (item: T) => void;
    onValueChange: (value: string) => void;
};